import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { routePaths } from '../pages/RootPage'
import { workspacePanelTypes } from '../pages/WorkspaceDetailsPage/WorkspaceDetailsPage'

const useUrlQuery = () => {
  const location = useLocation()

  const urlQuery = new URLSearchParams(useLocation().search)
  const pathname = useMemo(() => location.pathname, [location])
  const pathSegments = useMemo(
    () => location.pathname.split('/').filter(Boolean),
    [location]
  )
  const basePath = useMemo(() => `/${pathname.split('/')[1]}`, [pathname])
  const workspacePanelType = useMemo(
    () => `${pathname.split('/')[3]}`,
    [pathname]
  )

  const hasRiskReliefDeviationId = useMemo(() => {
    const deviationId = pathSegments[4]

    return (
      (pathname.includes(routePaths.WORKSPACE_DETAILS) &&
        pathname.includes(workspacePanelTypes.DEVIATIONS) &&
        !!deviationId) ||
      pathname.includes(
        routePaths.WORKSPACE_SMART_FUNCTION_DETAILS_RISK_REL_DEVIATION_CLASSIFICATION
      ) ||
      pathname.includes(
        routePaths.WORKSPACE_SMART_FUNCTION_DETAILS_RISK_REL_ROOT_CAUSE_DISCOVERY
      ) ||
      pathname.includes(
        routePaths.WORKSPACE_SMART_FUNCTION_DETAILS_RISK_REL_CAPA_GENERATION
      )
    )
  }, [pathname, pathSegments])

  const selectedRiskReliefDeviationId = useMemo(
    () =>
      hasRiskReliefDeviationId &&
      pathname.includes(routePaths.WORKSPACE_DETAILS)
        ? pathSegments[4]
        : hasRiskReliefDeviationId
        ? pathSegments[3]
        : undefined,
    [hasRiskReliefDeviationId, pathname, pathSegments]
  )

  const hasConformityCheckDocumentId = useMemo(() => {
    const documentId = pathSegments[4]

    return (
      (pathname.includes(routePaths.WORKSPACE_DETAILS) &&
        pathname.includes(workspacePanelTypes.DOCUMENTS) &&
        !!documentId) ||
      pathname.includes(routePaths.WORKSPACE_SMART_FUNCTION_DETAILS_OFR_QR)
    )
  }, [pathname, pathSegments])

  const selectedConformityCheckDocumentId = useMemo(
    () =>
      hasConformityCheckDocumentId &&
      pathname.includes(routePaths.WORKSPACE_DETAILS)
        ? pathSegments[4]
        : hasConformityCheckDocumentId
        ? pathSegments[3]
        : undefined,
    [hasConformityCheckDocumentId, pathname, pathSegments]
  )

  return {
    location,
    basePath,
    pathname,
    pathSegments,
    workspacePanelType,
    urlQuery,
    hasRiskReliefDeviationId,
    selectedRiskReliefDeviationId,
    hasConformityCheckDocumentId,
    selectedConformityCheckDocumentId,
  }
}

export default useUrlQuery
